import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AppMetadata } from '../models/app-metadata.model';
import { shareReplay } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AppMetadataService {
  private http = inject(HttpClient);

  private metadata$ = this.http
    .get<AppMetadata>(`${environment.apiUrl}app/metadata`)
    .pipe(shareReplay(1));

  getMetadata() {
    return this.metadata$;
  }
}
